export default __webpack_public_path__ + "static/media/oldfara.6202e820.jpg";